import React, { useEffect, useMemo, useRef, useState } from 'react'

import { ReactComponent as EditIcon } from "../../../assets/images/settings_icon/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/images/settings_icon/delete.svg";
import { useRegionAssignmentQuery, useV2DropdownListMutation } from '../../../redux/services/SRC';
import TableGrid from "../../../Components/common/TableGrid";
import { CallApi } from '../../../Components/common/CommonFunctions';
import { toast } from 'react-toastify';
import { Button, Form, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';

import { ReactComponent as SaveIcon } from "../../../assets/images/save.svg";
import ConfModal from '../../../Components/common/ConfModal';

const RegionAssignment = () => {

  const isMounted = useRef(false);
  const [regions, setRegions] = useState([])
  const [gridData, setGridData] = useState([])
  const [irregularity, setIrregularity] = useState([])
  const [formData, setFormData] = useState({})
  const [show, setShow] = useState(false)
  const [modalConf, setModalConf] = useState(false)
  const [confData, setConfData] = useState()
  const [modalPos, setModalPos] = useState('')
  const fetchRegions = () => {
    CallApi({
      endPoint: 'v2/service-recovery/dropdown-list',
      onSuccess: (res) => {
        setRegions(res.data.response_data.region_rules)
        setIrregularity(res.data.response_data.irregularity_type)
      },
      onError: (msg) => toast.error(msg)
    });}



  const columns = [
    {
      label: "", field: "actions", enableSearch: false, cls: "tw-2",
      renderCell: (row) => (
        <div className="tb_grid_actions">
          <EditIcon className="row_view" style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              modalOpen('ER', row)
            }} />
        </div>
      ),
    },
    { label: 'Reporting Location', field: 'location', cls: "tw-3" },
    { label: 'Assigned Region', field: 'region', cls: "tw-3" },
  ];

  const oColumns = [
    {
      label: "", field: "actions", enableSearch: false, cls: "tw-2",
      renderCell: (row) => (
        <div className="tb_grid_actions">
          <EditIcon className="row_view" style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              modalOpen('EO', row)
            }} />
          <DeleteIcon className="row_msg" style={{ cursor: "pointer", marginLeft: "6px" }}
            onClick={(e) => {
              e.stopPropagation();
              handleDelete(row)
            }} />
        </div>
      ),
    },
    { label: 'Irregularity Type', field: 'irregularity_type', cls: "tw-3" },
  ];

  const { data: myData, isFetching, refetch } = useRegionAssignmentQuery({
    // skip: pageDetails.pagesize === 0,
    // refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (isMounted.current) return;
    fetchRegions();
    refetch()
    isMounted.current = true;
  }, []);

  // useEffect(() => {
  //   if (myData) {
  //     const regionJson = myData?.response_data?.data?.region_json;
  //     if (!regionJson) return [];
  //     console.log('regionJson', regionJson);

  //     setFormData(regionJson)
  //     return Object.entries(regionJson).map(([key, value]) => {
  //       const matchedRegion = regions.find(r => r.value === value);
  //       setGridData({
  //         location: key,
  //         region: matchedRegion ? matchedRegion.label : ''
  //       });
  //     })
  //   }
  // }, [myData]);

  const transformedRows = useMemo(() => {
    if (myData) {
      const regionJson = myData?.response_data?.data?.region_json;
      if (!regionJson || !regions?.length) return [];

      setFormData(regionJson)
      return Object.entries(regionJson).map(([key, value]) => {
        const matchedRegion = regions.find(r => r.value === value);

        return {
          location: key,
          region: matchedRegion ? matchedRegion.label : ''
        };
      });
    }

  }, [myData, regions]);

  const regionsForm = [
    { title: 'Origin', name: 'Origin' },
    { title: 'Transit', name: 'Transit' },
    { title: 'Destination', name: 'Destination' },
    { title: 'Wrong Station', name: 'Wrong' },
  ]
  const modalOpen = (pos, data) => {
    setModalPos(pos)
    setShow(true)
    if (pos === 'EO') {
      setFormData(prev => ({
        ...data?.region_json,
        irregularity_type: data.irregularity_id
      }))
    } else {
      setFormData(myData?.response_data?.data?.region_json)
    }
  }
  const modalClose = () => {
    setShow(false)
  }

  const modalSave = () => {
    CallApi({
      endPoint: 'v2/service-recovery/update-region-rule',
      payload: formData,
      onSuccess: (res) => {
        const resCode = res.data.response_code;
        if (resCode === 200) {
          refetch()
          setShow(false)
        }
      },
      onError: (msg) => toast.error(msg)
    });
  }
  const handleDelete = (data) => {
    setConfData(data);
    setModalConf(true);
  }
  const handleConfDelete = () => {
    CallApi({
      endPoint: 'v2/service-recovery/delete-region-rule',
      payload: { id: confData.id },
      onSuccess: (res) => {
        const resCode = res.data.response_code;
        if (resCode === 200) {
          refetch()
          setModalConf(false);
        }
      },
      onError: (msg) => toast.error(msg)
    });
  }
  const confModalClose = () => {
    setConfData();
    setModalConf(false);
  }

  return (
    <>
      {modalConf &&
        <ConfModal
          header={`Delete Irregularity Type`}
          subHeader={`Are you sure you want to delete the type?`}
          modalConf={() => handleConfDelete()}
          closeModal={confModalClose}
          primaryBtn='Delete'
          secondaryBtn='Cancel'
        />
      }
      <div>
        <h4>Region Assignment</h4>
        <p>Configure automatic region routing rules for recovery records, based on reporting location and irregularity type.</p>
      </div>

      <hr />

      <h6>Default Routing Rules</h6>
      <p>Define the default region assignment applied to recovery records based on the reporting location.</p>
      <div className='setting_table auto_height tw-40'>
        <TableGrid
          columns={columns}
          rows={transformedRows}
          checkboxSelection={false}
          disablePagination={true}
          // totalRecords={propData?.address?.length || 0}
          // onClickRow={(row) => handleRowClick(row)}
          // loading={isFetching}
          rowKey='handler_contact_id'
        // bulkActions={bulkActions}
        />
      </div>
{console.log('formData', formData)}
      <hr />

      <h6>Irregularity Overrides</h6>
      <p>Override default region assignment rules for specific irregularity types.</p>
      <Button onClick={() => modalOpen('AO')}><FontAwesomeIcon icon={faPlus} /> Add Override</Button>
      <div className='setting_table auto_height tw-30'>
        <TableGrid
          columns={oColumns}
          rows={myData?.response_data?.irregularity}
          checkboxSelection={false}
          disablePagination={true}
          // totalRecords={propData?.address?.length || 0}
          // onClickRow={(row) => handleRowClick(row)}
          // loading={isFetching}
          rowKey='handler_contact_id'
        // bulkActions={bulkActions}
        />
      </div>
      <Modal show={show} onHide={modalClose} centered className='modal_bgw primary_modal R_Assignment'>
        <Modal.Header closeButton>
          <Modal.Title>
            {modalPos == 'AO' ? 'Add' : modalPos == 'EO' ? 'Edit' : 'Edit Region'} {modalPos !== 'ER' && ' Irregularity Override'}
            <p>{modalPos == 'AO' ? 'Define' : modalPos == 'EO' ? 'Update' : 'Default Routing Rules'} {modalPos !== 'ER' && 'region assignment rules for a specific irregularity type.'}</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body >
          {modalPos !== 'ER' &&
            <>
              <Form.Group>
                <Form.Label>Irregularity Type</Form.Label>
                <Select
                  options={irregularity}
                  onChange={(selected) => {
                    setFormData(prevFormData => {
                      const newFormData = { ...prevFormData, irregularity_type: selected.value };
                      return newFormData;
                    });
                  }}
                  placeholder="Irregularity Type"
                  className=''
                  name='irregularity_type'
                  value={irregularity.find(option => option.value == formData.irregularity_type) || ''}
                />
              </Form.Group>
            </>
          }
          <Form.Label>Assignment Rules</Form.Label>
          {regionsForm?.map((item, index) => (
            <Form.Group className='d-flex justify-content-between align-items-center mb-2' >
              <Form.Label>{item.title}</Form.Label>
              <Select
                options={regions}
                onChange={(selected) => {
                  setFormData(prevFormData => {
                    const newFormData = { ...prevFormData, [item.name]: selected.value };
                    return newFormData;
                  });
                }}
                placeholder="Irregularity Type"
                className=''
                name='irregularity_type'
                value={regions.find(option => option.value == formData[item.name]) || ''}
              />
            </Form.Group>
          ))}
          {console.log('formData', formData)}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={modalSave}  >
            <SaveIcon /> Save
          </Button>
        </Modal.Footer>
      </Modal >
    </>
  )
}

export default RegionAssignment;